import { useMPEFetch, useMutateMPEFetch } from '@retail/app/hooks';
import { useMgPrisConfig } from '@retail/app/stores/app-config';
import { useAuthContext } from '@retail/auth/data-access';
import {
  FieldTemplate,
  FieldTemplateDTO,
  UpdateAssortmentFields,
} from '@retail/member-config/types';
import { mpeApi } from '@retail/mgpris/config';
import { QueryOptions } from '@shared/fetch-utils';
import { buildUrl } from '@shared/utils';
import { useMemo } from 'react';

export function useUpdateAssortmentFields({ ...queryOptions }: QueryOptions = {}) {
  const { mpe } = useMgPrisConfig();
  const { token } = useAuthContext();

  return useMutateMPEFetch<void, UpdateAssortmentFields>({
    method: 'PUT',
    url: ({ assortmentId }) =>
      buildUrl({
        base: mpe.url,
        route: mpeApi.assortmentConfig.assortments.assortment.getFullLinkPath({ assortmentId }),
      }),
    token,
    ...queryOptions,
  });
}

interface FetchProps extends QueryOptions {
  brandId: string;
}
export function useFetchFieldTemplates({ brandId, ...queryOptions }: FetchProps) {
  const { mpe } = useMgPrisConfig();
  const { token } = useAuthContext();

  return useMPEFetch<FieldTemplateDTO[]>({
    method: 'GET',
    queryKey: ['assortment-fields-templates'],
    token,
    url: buildUrl({
      base: mpe.url,
      route: mpeApi.assortmentConfig.brands.brand.templates.getFullLinkPath({ brandId }),
    }),
    ...queryOptions,
  });
}
